module.exports = __webpack_public_path__ + "static/media/a25.8f566c32.jpg";